import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";
import Article from "../components/articles/article";

import INFO from "../data/user";
import SEO from "../data/seo";
import myArticles from "../data/articles";

import "./styles/articles.css";

const Articles = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "articles");

	// Using local images from the "public/images" folder
	const galleryImages = [
		"/images/gallery1.jpg",
		"/images/gallery2.jpg",
		"/images/gallery3.jpg",
		"/images/gallery4.jpg",
		"/images/gallery5.jpg",
		"/images/gallery6.jpg",
		"/images/gallery7.jpg",
		"/images/gallery8.jpg",
		"/images/gallery9.jpg",
		"/images/gallery10.jpg",
		"/images/gallery11.jpg",
		"/images/gallery12.jpg"
	];

	return (
		<React.Fragment>
			<Helmet>
				<title>{`Articles | ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				<NavBar active="articles" />
				<div className="content-wrapper">
					<div className="articles-logo-container">
						<div className="articles-logo">
							<Logo width={46} />
						</div>
					</div>

					<div className="articles-main-container">
						<div className="title articles-title">
							{INFO.articles.title}
						</div>

						<div className="subtitle articles-subtitle">
							{INFO.articles.description}
						</div>

						<div className="articles-container">
							<div className="articles-wrapper">
								{myArticles.map((article, index) => (
									<div
										className="articles-article"
										key={(index + 1).toString()}
									>
										<Article
											key={(index + 1).toString()}
											date={article().date}
											title={article().title}
											description={article().description}
											link={"/article/" + (index + 1)}
										/>
									</div>
								))}
							</div>
						</div>

						<div className="gallery-section">
							<h2 className="gallery-title">Gallery</h2>
							<div className="gallery-container">
								{galleryImages.map((image, index) => (
									<img key={index} src={image} alt={`Gallery ${index + 1}`} className="gallery-image" />
								))}
							</div>
						</div>
					</div>

					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Articles;
